<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title" >Query Management / View</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="mb40">
                    <div class="add-store-block input-style mb20 ">
                        <form>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5"> 
                                      <h6>Name :</h6>    
                                    </label>
                                    <p  class="col-md-7"> {{queryList?.userId?.firstName}} {{queryList?.userId?.lastName}} </p>
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                        <h6>Email :</h6>    

                                    </label>
                                    <p class="col-md-7"> {{queryList?.userId?.email}}  </p>
                                </div>
                            </div>

                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                        <h6>Description : </h6>
                                    </label>
                                    <p class="col-md-7"> {{queryList?.query}} </p>
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                    <h6>Query Date :</h6>    
                                    </label>
                                    <p class="col-md-7"> {{queryList?.createdAt | date : 'd/M/y' :'UTC'}} </p>
                                </div>
                            </div>

                            <div class="text-center mt-5">
                                <button class="btn btn-theme" routerLink="/query-mgt">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>